import { Flex } from '@ifood/pomodoro-components';
import { Close, Reorder } from '@ifood/pomodoro-icons';
import { FormattedMessage } from 'gatsby-plugin-intl';
import React, { FC, useState } from 'react';

import { ROUTER_PATHS } from '@constants/router';
import { useNavigation } from 'hooks/navigation';
import HeaderLogo from 'modules/Header/components/HeaderLogo';

import { Container, Content, HeaderDesktop, HeaderMobile, Item, MobileNavBar, NavBar } from './styles';

const intPrefix = 'header.embeddables';

export const HeaderEmbeddables: FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const handleClick = (id: string): void => {
    setIsOpen(false);
    const element = document.getElementById(id);
    element?.scrollIntoView({ block: 'start', behavior: 'smooth' });
  };

  const goToDocs = useNavigation(ROUTER_PATHS.EMBEDDABLES_DOCS);

  return (
    <Container>
      <HeaderDesktop>
        <Content>
          <HeaderLogo />
          <NavBar>
            <Item onClick={(): void => handleClick('how-to')}>
              <FormattedMessage id={`${intPrefix}.how-to`} />
            </Item>
            <Item onClick={(): void => handleClick('benefits')}>
              <FormattedMessage id={`${intPrefix}.benefits`} />
            </Item>
            <Item onClick={(): void => handleClick('services')}>
              <FormattedMessage id={`${intPrefix}.services`} />
            </Item>
            <Item onClick={goToDocs}>
              <FormattedMessage id="core.header.embeddables.docs" />
            </Item>
          </NavBar>
        </Content>
      </HeaderDesktop>
      <HeaderMobile>
        <Flex alignItems="center" width="100%" justifyContent="space-between">
          <HeaderLogo />
          {isOpen ? (
            <Close width={32} height={32} onClick={(): void => setIsOpen(false)} />
          ) : (
            <Reorder width={32} height={32} onClick={(): void => setIsOpen(true)} />
          )}
        </Flex>
        {isOpen && (
          <MobileNavBar>
            <Item onClick={(): void => handleClick('how-to')}>
              <FormattedMessage id={`${intPrefix}.how-to`} />
            </Item>
            <Item onClick={(): void => handleClick('benefits')}>
              <FormattedMessage id={`${intPrefix}.benefits`} />
            </Item>
            <Item onClick={(): void => handleClick('services')}>
              <FormattedMessage id={`${intPrefix}.services`} />
            </Item>
            <Item onClick={goToDocs}>
              <FormattedMessage id="core.header.embeddables.docs" />
            </Item>
          </MobileNavBar>
        )}
      </HeaderMobile>
    </Container>
  );
};
